"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _ChevronDown = _interopRequireDefault(require("@insided/shared/icons/ChevronDown"));

var _Calendar = _interopRequireDefault(require("@insided/destination/icons/Calendar"));

var _classnames = _interopRequireDefault(require("classnames"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var fpConfig = {
  enableTime: true,
  noCalendar: true,
  dateFormat: 'H:i',
  static: true
};

var TimepickerV2 = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(TimepickerV2, _Component);

  var _super = _createSuper(TimepickerV2);

  function TimepickerV2() {
    var _this;

    (0, _classCallCheck2.default)(this, TimepickerV2);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      selectedDates: []
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "input", null);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "closed", 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "instance", null);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "flatpickr", null);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleClickOutside", function (e) {
      var _document$querySelect;

      if (!((_document$querySelect = document.querySelector('.control-time-picker-input-wrapper .flatpickr-calendar')) !== null && _document$querySelect !== void 0 && _document$querySelect.contains(e.target))) {
        var _this$instance;

        (_this$instance = _this.instance) === null || _this$instance === void 0 ? void 0 : _this$instance.close();
      }
    });
    return _this;
  }

  (0, _createClass2.default)(TimepickerV2, [{
    key: "loadFlatpickr",
    value: // Store flatpickr module reference
    function () {
      var _loadFlatpickr = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (this.flatpickr) {
                  _context.next = 4;
                  break;
                }

                _context.next = 3;
                return import('flatpickr');

              case 3:
                this.flatpickr = _context.sent.default;

              case 4:
                return _context.abrupt("return", this.flatpickr);

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function loadFlatpickr() {
        return _loadFlatpickr.apply(this, arguments);
      }

      return loadFlatpickr;
    }()
  }, {
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
        var _this2 = this;

        var flatpickr, _this$props, _onClose, value, disableInput;

        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!this.input) {
                  _context2.next = 6;
                  break;
                }

                _context2.next = 3;
                return this.loadFlatpickr();

              case 3:
                flatpickr = _context2.sent;
                _this$props = this.props, _onClose = _this$props.onClose, value = _this$props.value, disableInput = _this$props.disableInput;
                flatpickr(this.input, _objectSpread(_objectSpread({}, fpConfig), {}, {
                  defaultDate: value,
                  inline: disableInput,
                  onReady: function onReady(_a, _b, instance) {
                    _this2.instance = instance;

                    _this2.addHandler();
                  },
                  onChange: function onChange(selectedDates) {
                    _this2.setState({
                      selectedDates: selectedDates
                    });
                  },
                  onClose: function onClose() {
                    _onClose(_this2.state.selectedDates);

                    _this2.closed = Date.now();

                    _this2.removeHandler();
                  }
                }));

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "addHandler",
    value: function addHandler() {
      window.document.addEventListener('mousedown', this.handleClickOutside);
    }
  }, {
    key: "removeHandler",
    value: function removeHandler() {
      window.document.removeEventListener('mousedown', this.handleClickOutside);
    }
  }, {
    key: "toggleOpen",
    value: function toggleOpen() {
      var _this$instance2;

      Date.now() - this.closed > 200 && ((_this$instance2 = this.instance) === null || _this$instance2 === void 0 ? void 0 : _this$instance2.open());
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var disableInput = this.props.disableInput;
      return (0, _preact.h)("div", {
        className: "control-time-picker-input-wrapper"
      }, !disableInput && (0, _preact.h)("a", {
        onClick: function onClick() {
          return _this3.toggleOpen();
        }
      }, (0, _preact.h)(_Calendar.default, {
        className: "icon-calendar"
      })), !disableInput && (0, _preact.h)("a", {
        onClick: function onClick() {
          return _this3.toggleOpen();
        }
      }, (0, _preact.h)(_ChevronDown.default, {
        className: "icon-dropdown",
        width: 16
      })), (0, _preact.h)("input", {
        className: (0, _classnames.default)('control-date-picker', {
          'input-hidden': disableInput
        }),
        placeholder: "Select time",
        ref: function ref(input) {
          return _this3.input = input;
        }
      }));
    }
  }]);
  return TimepickerV2;
}(_preact.Component);

exports.default = TimepickerV2;